import { Carousel } from 'react-responsive-carousel';
import { useTranslation } from 'react-i18next';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EnableBankingLogo from '../../../Images/Logos/White/Enable_banking_white.svg';
import FortnoxLogo from '../../../Images/Logos/White/fortnox_white.svg';
import VismaLogo from '../../../Images/Logos/White/Visma_spcs_white.svg';
import EkonomikaLogo from '../../../Images/Logos/White/Ekonomika_white.png';
import YourCFOLogo from '../../../Images/Logos/White/yourcfo_white.png';
import CategoriaLogo from '../../../Images/Logos/White/Categoria_white.png';
import AccountecLogo from '../../../Images/Logos/White/accountec_white.png';
import OPRLogo from '../../../Images/Logos/White/opr_white.svg';
import BjornLundenLogo from '../../../Images/Logos/White/Bjorn-Lunden-white.png';

export default function LogoSection() {
  const { t } = useTranslation();
  return (
    <div className="section logo-section">
      <div className="logo-row">
        <img src={EnableBankingLogo} alt="company_logo" />
        <img src={FortnoxLogo} alt="company_logo" />
        <img src={VismaLogo} alt="company_logo" />
        <img src={BjornLundenLogo} alt="company_logo" />
        <img src={EkonomikaLogo} alt="company_logo" />
        <img src={YourCFOLogo} alt="company_logo" />
        <img src={CategoriaLogo} alt="company_logo" />
        <img src={AccountecLogo} alt="company_logo" />
        <img src={OPRLogo} alt="company_logo" style={{ height: '48px' }} />
      </div>
      <p className="section-title">{t('shared.testimonials-uppercase')}</p>
      <Carousel
        axis="horizontal"
        swipeable
        emulateTouch
        interval={10000}
        infiniteLoop
        autoPlay
        stopOnHover
        showThumbs={false}
      >
        <div className="quote-container">
          <p className="section-text">{t('quote-carousel.quotes.0.text')}</p>
          <p className="author">- {t('quote-carousel.quotes.0.author')}</p>
        </div>
        <div className="quote-container">
          <p className="section-text">{t('quote-carousel.quotes.1.text')}</p>
          <p className="author">- {t('quote-carousel.quotes.1.author')}</p>
        </div>
        <div className="quote-container">
          <p className="section-text">{t('quote-carousel.quotes.2.text')}</p>
          <p className="author">- {t('quote-carousel.quotes.2.author')}</p>
        </div>
        <div className="quote-container">
          <p className="section-text">{t('quote-carousel.quotes.3.text')}</p>
          <p className="author">- {t('quote-carousel.quotes.3.author')}</p>
        </div>
      </Carousel>
    </div>
  );
}
